import { DashboardFilter } from "../../reducers/vendor/VendorDashboradFilterReducer";

export type DashboardFilterAction =
  | {
      type: "ON_CHANGE_VENDOR_FILTER_DATA";
      payload: [input: string, value: any];
    }
  | {
      type: "RESET_VENDOR_FILTER";
      payload: [];
    };

function updateVendorFilterData(input: string, value: any): DashboardFilterAction {
  return {
    type: "ON_CHANGE_VENDOR_FILTER_DATA",
    payload: [input, value],
  };
}

function resetVendorFilter(): DashboardFilterAction {
  return {
    type: "RESET_VENDOR_FILTER",
    payload: [],
  };
}
export const DashboardFilterActions = {
  updateVendorFilterData,
  resetVendorFilter,
};

